import React from 'react'

const Course = () => {
  return (
    <div>
      
    </div>
  )
}

export default Course
